import React from "react"
import { Card, CardBody, Badge } from "reactstrap"
import SectionHeader from "components/Common/SectionHeader"
import ThemePlaceholder from "components/Common/ThemePlaceholder"

// Helper function to check if value exists
const hasValue = (value) => {
  if (value === null || value === undefined) return false
  if (typeof value === "string" && value.trim() === "") return false
  if (Array.isArray(value) && value.length === 0) return false
  return true
}

const PersonItem = ({ person, index }) => {
  const hasName = hasValue(person.name)
  const hasDesignation = hasValue(person.designation)
  const hasMobiles =
    person.mobile && Array.isArray(person.mobile) &&
    person.mobile.some(m => hasValue(m))

  return (
    <div className="mb-3 pb-3 border-bottom">
      <div className="d-flex justify-content-between align-items-start mb-2">
        <div>
          <strong className="d-block">
            {hasName ? person.name : <Badge color="light" className="text-muted">Unnamed Person</Badge>}
          </strong>
          {hasDesignation && (
            <small className="text-muted d-block">({person.designation})</small>
          )}
        </div>
        <Badge color="light">#{index + 1}</Badge>
      </div>

      {hasMobiles ? (
        <div className="d-flex flex-column gap-1">
          {person.mobile.map((mobile, mobIndex) => (
            hasValue(mobile) && (
              <div key={mobIndex} className="d-flex align-items-center gap-2">
                <i className="bx bx-phone text-muted" style={{ fontSize: "14px" }}></i>
                <span>{mobile}</span>
              </div>
            )
          ))}
        </div>
      ) : (
        <Badge color="light" className="text-muted">No mobile numbers</Badge>
      )}
    </div>
  )
}

const AuthorizedPersonsCard = ({ persons, loading, action = null }) => {
  if (loading) {
    return (
      <Card className="border-0 shadow-sm mb-4">
        <CardBody className="p-3">
          <SectionHeader
            icon="bx bx-user"
            title="Authorized Persons"
            action={action}
          />
          <div className="py-2">
            <ThemePlaceholder style={{ width: "100%", height: 100, borderRadius: 4 }} />
          </div>
        </CardBody>
      </Card>
    )
  }

  const hasPersons = persons && Array.isArray(persons) && persons.length > 0

  return (
    <Card className="border-0 shadow-sm mb-4">
      <CardBody className="p-3">
        <SectionHeader
          icon="bx bx-user"
          title={`Authorized Persons (${hasPersons ? persons.length : 0})`}
          action={action}
        />
        
        {hasPersons ? (
          <div className="specs-list">
            {persons.map((person, index) => (
              <PersonItem 
                key={person.id || index} 
                person={person} 
                index={index} 
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-3">
            <i className="bx bx-user-x display-4 text-muted mb-2"></i>
            <p className="text-muted mb-0">No authorized persons found</p>
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default AuthorizedPersonsCard